export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCWvlUEfqooKrAg524lwA_uARVaP5kr3V0',
    authDomain: 'alliancecourses.firebaseapp.com',
    databaseURL: 'https://alliancecourses.firebaseio.com',
    projectId: 'alliancecourses',
    storageBucket: 'alliancecourses.appspot.com',
    messagingSenderId: '45586190960',
    appId: '1:45586190960:web:8976803a50edb0b4ee5ab5'
  }
};
